import { ProductSchema, ProductSchemaData } from "../../../schema/data/product.schema";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FormRenderer } from "@data-driven-forms/react-form-renderer";
import { PrizeetMappers } from "../../../schema/custom-form/prizeet-mappers";
import React from "react";
import { ProductFormTemplate } from "./ProductFormTemplate";
import { ProductCreateProps } from "./CreateProductForm";

interface ProductEditProps extends ProductCreateProps {
  editData: ProductSchemaData;
}

export const EditProductForm = (props: ProductEditProps) => {
  const { data, editData, onClose, fullWidth, title, openModal, maxWidth } = props;
  const schema = ProductSchema({ ...data, editData: { ...editData } });

  return (
    <>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={openModal}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <FormRenderer
            componentMapper={{ ...PrizeetMappers }}
            schema={schema}
            FormTemplate={(data) => <ProductFormTemplate formFields={data.formFields} onSubmit={props.onSubmit} />}
            subscription={{ values: true }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
